import { render, staticRenderFns } from "./Uploads.vue?vue&type=template&id=57f6116a&scoped=true&"
import script from "./Uploads.vue?vue&type=script&lang=js&"
export * from "./Uploads.vue?vue&type=script&lang=js&"
import style0 from "./Uploads.vue?vue&type=style&index=0&id=57f6116a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f6116a",
  null
  
)

export default component.exports